import { LibraryType } from './../../enums/regulator/regulator-status';

export class ChangeViewerLibrary {
  id: number;
  libraryName: string;
  libraryType: LibraryType;
  externalUserId: string;
  isSharable: boolean;
  isActive: boolean;
  isGlobal: boolean;
  parentId: number;
  totalCount:number;

  constructor() {
    this.id = 0;
    this.libraryName = '';
    this.libraryType = LibraryType.Static;
    this.externalUserId = '';
    this.isSharable = false;
    this.isActive = false;
    this.isGlobal = false;
    this.parentId = 0;
    this.totalCount=0;
  }
}
